// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { cpfUtil, phoneUtil } from "@3778.care/goban";

const leapYears = 3.15576e10;
const getAge = (birthDate) =>
  Math.floor((new Date() - new Date(birthDate).getTime()) / leapYears);

const parse = (patient) => {
  const name = patient?.name?.[0]?._patient_name_given
    .map((n) => n?.given)
    .join(" ");
  const surname = patient?.name?.[0]?.family;
  const fullName = `${name} ${surname}`;
  const organization = patient?.organization?._organization_alias?.alias;
  const organizationId = patient?.organization?._organization_alias?.id;
  const [cpf] = (patient?.cpf ?? []).map(({ value }) => value);
  const [email] = (patient?.telecom ?? [])
    .filter((t) => t.system === "email")
    .map(({ value }) => value);
  const [phone] = (patient?.telecom ?? [])
    .filter((t) => t.system === "phone")
    .map(({ value }) => value);
  const gender = patient?.gender;
  const birthdate = patient?.birthdate;
  const age = patient ? getAge(birthdate) : null;
  const cep = patient?.address?.[0]?.cep;
  const state = patient?.address?.[0]?.state;
  const city = patient?.address?.[0]?.city;

  return {
    name,
    surname,
    fullName,
    email,
    organization,
    organizationId,
    cpf: cpf ? cpfUtil.format(cpf) : "",
    phone: phone ? phoneUtil.formatNational(phone) : "",
    gender,
    birthdate,
    age,
    cep,
    state,
    city,
  };
};

export { parse };
